import React from 'react';
import './podcastCard.scss';
import useScript from '../commons/hooks/useScript';
import twitterIcon from '../assets/twitter.svg';
import linkedInIcon from '../assets/linkedin_article.svg';
import Img from 'gatsby-image';
import ReactMarkdown from 'react-markdown/with-html';

interface Props {
  name: string;
  title: string;
  description: string;
  podcastUrl: string;
  profileImageUrl: any;
  twitterUrl?: string;
  linkedInUrl?: string;
}

const PodcastCard: React.FC<Props> = ({
  title,
  name,
  podcastUrl,
  profileImageUrl,
  linkedInUrl,
  twitterUrl,
  description,
}) => {
  useScript(podcastUrl);

  const getPodcastId = (str: string) => {
    if (str.includes('Juan')) {
      return 'buzzsprout-small-player-1238366-artist-Juan-20Jimenez';
    }
    if (str.includes('Winter')) {
      return 'buzzsprout-small-player-1238366-artist-Adam-20Winter';
    }
    if (str.includes('dennis')) {
      return 'buzzsprout-player-7917928';
    }
    if (str.includes('jason')) {
      return 'buzzsprout-player-10358763';
    }
    if (str.includes('caroline')) {
      return 'buzzsprout-player-12421093';
    }
  };

  return (
    <div className="podcastCardContainer">
      <Img fluid={profileImageUrl} />
      <div className="podcastCardInner">
        <h4>{name}</h4>
        <h3>{title}</h3>
        <ReactMarkdown escapeHtml={false} source={description} />
        <div className="podcastCardInnerSocialContainer">
          {twitterUrl && (
            <a href={twitterUrl} target="_blank">
              <img alt="twitterIcon" src={twitterIcon} />
            </a>
          )}
          {linkedInUrl && (
            <a href={linkedInUrl} target="_blank">
              <img alt="linkedinIcon" src={linkedInIcon} />
            </a>
          )}
        </div>
        <div id={getPodcastId(podcastUrl)} />
      </div>
    </div>
  );
};

export default PodcastCard;
